// TODO: dictionary

import React from "react";
import { Table } from "semantic-ui-react";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { FLOWABLE_BASE_URL, DEFAULT_DATETIME_FORMAT, BUDGET_FILE_HEADERS } from "globals/constants";
import styles from "./ResearchTeamBudgetImporter.css";
import { Model } from "@flowable/forms";
import moment from "moment";
import { api } from "services";

const uploadDefinition = {
	type: "upload",
	value: "{{file}}",
	extraSettings: {
		autoupload: true,
		acceptFileTypes: ".xlsx,.xls,.xlsm",
		maxFiles: 1,
		downloadUrl: "rest/file/",
		allowDelete: "newOnly",
		preview: "none",
		//fileService: `${FLOWABLE_BASE_URL}/content-api/`,
		fileService: `${FLOWABLE_BASE_URL}/cayuse-api/`,
		uploadUrl: `${FLOWABLE_BASE_URL}/platform-api/content-items/provisional`,
		updateFileUrl: `${FLOWABLE_BASE_URL}/platform-api/content-items//new-version`
	}
};

// TODO: move this to a place it can be easily shared
const toCurrency = value => {
	return value.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
	});
};

export class ResearchTeamBudgetImporter extends Model.FormComponent {
	constructor (props) {
		super(props);
		this.state = {
			uploadId: null
		};
	}

	componentDidUpdate () {
		const { config, onChange } = this.props;
		const resolvedValues = config.resolvedUpload.value;
		const hasValues = isNonEmptyArray(resolvedValues);
		const hasId = hasValues && resolvedValues[0].id;

		if (hasValues && hasId && resolvedValues[0].id !== this.state.uploadId) {
			this.setState({ uploadId: resolvedValues[0].id });
			this.uploadFile(resolvedValues);
		} else if (config?.value?.file?.length === 0 && this.state.uploadId) {
			// user removed the file from the upload Component
			onChange({ $path: "fileData", $value: null });
			onChange({ $path: "uploadUser", $value: null });
			this.setState({ uploadId: null });
		}
	}

	uploadFile (fileInfo) {
		const { config, onChange } = this.props;
		const promises = [
			api.form.getBudget({ id: fileInfo[0].id }),
			api.tenant.getProductUser({ userId: fileInfo[0].lastModifiedBy }),
		];

		Promise.all(promises).then(results => {
			if (!config.value?.fileData && results[0]) {
				onChange({ $path: "fileData", $value: results[0] });
			}
			if (!config.value?.uploadUser && results[1].user) {
				onChange({ $path: "uploadUser", $value: results[1].user });
			}
		});
	};

	renderBudgetRow (rowName, amount, style) {
		return (
			<div className={ style } key={rowName.replace(/ /g, "-")}>
				<div className={styles.budgetItem}><strong>{rowName}</strong></div>
				<div>
					<strong>
						{toCurrency(amount)}
					</strong>
				</div>
			</div>
		);
	}

	renderBudgetRows (parsedData) {
		const rows = [];
		let directCosts = 0;
		let sponsorCosts = 0;
		let costShare = 0;
		let total = 0;

		for (const key in parsedData) {
			const amount = parsedData[key] === "" ? 0 : parseFloat(parsedData[key].replace(/,/g, ""));

			// figure out which total to add
			if (BUDGET_FILE_HEADERS.directCosts.includes(key)) {
				directCosts += amount;
			} else if (BUDGET_FILE_HEADERS.sponsorCosts.includes(key)) {
				sponsorCosts += amount;
			} else if(BUDGET_FILE_HEADERS.costShare.includes(key)) {
				costShare += amount;
			}

			// render row
			rows.push(this.renderBudgetRow(BUDGET_FILE_HEADERS.displayMap[key], amount, styles.budgetRow));

			// render subtotal rows
			if (key === BUDGET_FILE_HEADERS.directCosts[BUDGET_FILE_HEADERS.directCosts.length - 1]) {
				rows.push(this.renderBudgetRow("Total Direct Costs", directCosts, styles.subTotalBudgetRow));
			}
			if (key === BUDGET_FILE_HEADERS.sponsorCosts[BUDGET_FILE_HEADERS.sponsorCosts.length - 1]) {
				sponsorCosts += directCosts;
				rows.push(this.renderBudgetRow("Total Sponsor Costs", sponsorCosts, styles.subTotalBudgetRow));
			}
			if (key === BUDGET_FILE_HEADERS.costShare[BUDGET_FILE_HEADERS.costShare.length - 1]) {
				rows.push(this.renderBudgetRow("Total Cost Share", costShare, styles.subTotalBudgetRow));
			}
		}

		// render total row
		total = sponsorCosts + costShare;
		rows.push(this.renderBudgetRow("Total Project Cost", total, styles.totalBudgetRow));

		return rows;
	};

	render () {
		const { Components, config, onChange } = this.props;

		if (!config.resolvedUpload) {
			return null;
		}

		return (
			<div className={styles.container}>
				<div className={`${styles.budgetSummaryHeader}`}>
					<h3>Budget Summary</h3>
				</div>
				<div>
					{config.description}
				</div>
				<div className={`${styles.budgetInfoHeader}`}>
					<div className={styles.budgetInfoHeaderColumn1}><strong>Budget Item</strong></div>
					<div className={styles.budgetInfoHeaderColumn2}><strong>Total</strong></div>
				</div>
				{ config.value?.fileData
					?
					this.renderBudgetRows(config.value?.fileData)
					:
					<div className={`${styles.budgetInfoRow}`}>
						<div className={styles.budgetInfoRowColumn}><i>No Buget Information Uploaded</i></div>
					</div>
				}
				<div className={`${styles.label}`}>
					<label>Detailed Budget</label>
				</div>
				<div>
					{config.attachmentDescription}
				</div>
				<Table singleLine>
					<caption>Research Team Budget</caption>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Name</Table.HeaderCell>
							<Table.HeaderCell>Uploaded By</Table.HeaderCell>
							<Table.HeaderCell>Date</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					{ config.value?.fileData
						?
						<Table.Body>
							<Table.Row>
								<Table.Cell>{config.value?.file[0]?.name}</Table.Cell>
								<Table.Cell>
									{`${config.value?.uploadUser?.firstName} ${config.value?.uploadUser?.lastName}`}
								</Table.Cell>
								<Table.Cell>
									{moment(config.value?.file[0]?.lastModified).format(DEFAULT_DATETIME_FORMAT)}
								</Table.Cell>
							</Table.Row>
						</Table.Body>
						:
						<Table.Body>
							<Table.Row>
								<Table.Cell colSpan="3" textAlign={"center"} className={styles.emptyUploadInfo}>
									<i>No budget found. Upload a budget .xls below</i>
								</Table.Cell>
							</Table.Row>
						</Table.Body>
					}
				</Table>
				<Components.upload {...this.props}
					config={config.resolvedUpload}
					onChange={value => onChange( { $path: config.resolvedUpload.$path, $value: value })}
				></Components.upload>
			</div>
		);
	}

	static $resolve (unresolved, scope, addData, Components) {
		const resolve = Components.panel.$resolve;
		const resolved = resolve(unresolved, scope, addData);
		const disabled = resolved.enabled === false;
		const resolvedUpload = resolve(uploadDefinition, resolved.value, addData, disabled);

		return { ...resolved, resolvedUpload };
	}
}

export default ResearchTeamBudgetImporter;
